<script setup>
import { ref } from 'vue';
import SearchForm from './search/Form.vue';
import FilterTrigger from './filter/Trigger.vue';

const fetching = ref(false);
</script>

<template>
    <div>
        <div class="flex items-center">
            <div class="grow min-w-0">
                <SearchForm @fetching="fetching = $event" />
            </div>
            <FilterTrigger as="app-icon-button" icon="filter" />
        </div>
        <div v-if="fetching" class="flex items-center justify-center mt-2 w-full">
            <icon-loader class="size-5" />
        </div>
    </div>
</template>
